import { GetMemberCountThunk } from "core/membersCount/membersCount.thunk";
import { useRequest } from "./useRequest";
import { useDeepLinks } from "./useDeepLinks";

const useValidateChannelMembersCount = (minMember: number) => {
  const { sendRequest: getmemberCount } = useRequest(GetMemberCountThunk);
  const { isDeepLink } = useDeepLinks();

  function validateChannelMemberCount(
    link: string,
    onSuccess: (response: boolean, notFound: boolean) => void
  ) {
    getmemberCount({
      link: link,
      onSuccess: (data?: any) => {
        const { count } = data;
        onSuccess(
          count > minMember || count <= 0,
          count === -1 && link.includes("ble.ir") && !isDeepLink(link)
        );
      },
    });
  }

  return validateChannelMemberCount;
};

export default useValidateChannelMembersCount;
